/**
 * EventON Promote: blocks - Popup
 *
 * Registering a shortcode block with Gutenberg.
 */
/*jshint esversion: 6 */
//  Import CSS.
import './style.scss';
import './editor.scss';

const { __ } = wp.i18n; // Import __() from wp.i18n
const { registerBlockType } = wp.blocks; // Import registerBlockType() from wp.blocks



// Extend component
const { Component } = wp.element;
// Register editor components
const {
	InspectorControls,
} = wp.editor;
var el = wp.element.createElement;
// Register components
const {
    PanelBody,
    SelectControl,
    ToggleControl,
    TextControl,
} = wp.components;

registerBlockType( 'mmt-promote/promote-slidein', {
    // Block name. Block names must be string that contains a namespace prefix. Example: my-plugin/my-custom-block.
    title: __( 'Promote Slidein' ), // Block title.
    icon: {
        foreground: '#FF6978 ',
        src: 'shield'
        },
    category: 'mmt-promote-block', // Block category — Group blocks together based on common traits E.g. common, formatting, layout widgets, embed.
    keywords: [
        __( 'Promote' ),
        __( 'Event' ),
        __( 'promote-slidein' ),
    ],
    attributes: {
        slideinEventID: {
            type: 'string',
            default: '',
        },
        slideinLoadTime: {
            type: 'string',
            default: 300,
        },
        slideinOptin: {
            type: 'bool',
            default: false
        },
    },
    supportHTML: true,

    //edit: PromotePopup,
    edit: function( props  ){
        var slideinEventID = props.attributes.slideinEventID;
        var slideinLoadTime = props.attributes.slideinLoadTime;
        var slideinOptin = props.attributes.slideinOptin;
        var setAttributes = props.setAttributes;

        var isPremium = mmt_promote_block_plans_fm.is_plan_premium;
        let premiumDataTxt;
        let premiumDataTgl;
        if (isPremium) {
            premiumDataTxt =
                <TextControl
                    label = {__('Load Time', 'mmt-promote')}
                    placeholder={ __( 'e.g 1000 ( in m.s )', 'mmt-promote' ) }
                    value={ slideinLoadTime }
                    className='epa-popup-load-time'
                    onChange={ ( value ) => setAttributes( { slideinLoadTime: value } ) }
                />;
            premiumDataTgl =
                <ToggleControl
                    label={__('Enable Optin Form', 'mmt-promote')}
                    checked={slideinOptin}
                    onChange= { (option) => setAttributes({slideinOptin: option }) }
                />;
        }
        return [
            <div className={props.className} key={props.className}>
            <h4 id="mmt-propmote-slidein-section-title">{__('EventON Promote Slidein', 'mmt-promote')}</h4>
            <p>{__('Please check right hand side Block Panel for settings.','mmt-promote')}</p>
                <InspectorControls>
                    <PanelBody title={ __( 'Slidein Settings', 'mmt-promote' ) } >
                        <TextControl 
                                label = {__('Event ID', 'mmt-promote')}
                                placeholder={ __( 'e.g 333', 'mmt-promote' ) }
                                value= {slideinEventID}
                                className='epa-popup-event-id'
                                onChange={( value ) => setAttributes( { slideinEventID: value } )}
                        />
                        {premiumDataTxt}
                        {premiumDataTgl}
                        </PanelBody>
                </InspectorControls>
            </div>
        ];
    },

    save: function(props) {
        //TextControl.Content
        return null;
        
        },
} );
